export default __webpack_public_path__ + "static/reaction-marketing-01a0526a7a23f1a400f1cb50ba719436.png";